module.exports = __webpack_public_path__ + "static/img/RAC168_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC168_1.png
// module id = gUnS
// module chunks = 0